// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet overig API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfSUREbusinessManagementSearchSearchDto } from '../model/collectionResultOfSUREbusinessManagementSearchSearchDto.ts';

import type { SearchGetParams } from '../model/searchGetParams.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Geeft relaties en (niet gearchiveerde) recente activiteiten terug
 */
export const searchGet = (
  params?: MaybeRefOrGetter<SearchGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfSUREbusinessManagementSearchSearchDto>(
    { url: `/api/v1/search`, method: 'GET', params, signal },
    options,
  );
};

export const getSearchGetQueryKey = (params?: MaybeRefOrGetter<SearchGetParams>) => {
  return ['api', 'v1', 'search', ...(params ? [params] : [])] as const;
};

export const getSearchGetQueryOptions = <
  TData = Awaited<ReturnType<typeof searchGet>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRefOrGetter<SearchGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSearchGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchGet>>> = ({ signal }) =>
    searchGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchGet>>,
    TError,
    TData
  >;
};

export type SearchGetQueryResult = NonNullable<Awaited<ReturnType<typeof searchGet>>>;
export type SearchGetQueryError = ErrorType<unknown>;

/**
 * @summary Geeft relaties en (niet gearchiveerde) recente activiteiten terug
 */

export function useSearchGet<
  TData = Awaited<ReturnType<typeof searchGet>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRefOrGetter<SearchGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
